module.exports = __webpack_public_path__ + "static/roboto-v20-latin-italic-fe65b8335ee19dd944289f9ed3178c78.woff";